import React from 'react'
import { Modal, ModalBody } from "react-bootstrap";

const AddMissedVisitPopup = (props) => {
    const { ID, onClose, onCloseSave, openPopup, name, searchParam, setSearchParam } = { ...props }

    const handleOnChange = (e, nameParam, type) => {


        let modal = { ...searchParam };

        if (type === 'clear') {
            modal[nameParam] = "";
        }
        else {
            const { name, value } = e.target
            modal[name] = value;
        }
        setSearchParam(modal);

    }

    return (
        <Modal show={openPopup} onHide={openPopup} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za_add_reason_popup  za_missed-visit">
            <Modal.Body>
                <div className='d-flex justify-content-between align-items-center px-10'>
                    <p className='heading fs-12 red_clr'>Missed Visit</p>
                    <i className='icon-Icon-metro-cross' onClick={() => onClose()}></i>
                </div>
                <div className=' br-top-1  ar-border-color my-2'></div>
                <div className="input px-10">
                    <label className='text fs-12  mb-1'> Reason</label>
                    <textarea type="text" className='form-control' id={name} name={name} value={searchParam.MissVisitStatus} onChange={(e) => handleOnChange(e)} />
                </div>

            </Modal.Body>
            <div className="modal_footer ">
                <div className='za-button d-flex justify-content-end align-items-center gap-1'>
                    <button className='btn btn-gray text fs-12 px-10 ' onClick={(e) => { handleOnChange(e, 'MissVisitStatus', 'clear'); onClose() }}> Cancel</button>
                    <button className='btn btn-red  text fs-12 px-10 text-white' onClick={() => onCloseSave()}>OK</button>
                </div>
            </div>

        </Modal>
    )
}

export default AddMissedVisitPopup
